import React from 'react'
import { useQrcode } from '../_load/QrcodeLoader'
import AssetPage from './AssetPage'
import PlacePage from './PlacePage'

const ContentPage = () => {
  const qrcode = useQrcode()

  if (qrcode.type === 'assets') return <AssetPage />
  return <PlacePage />
}

export default ContentPage
